<template>
   <div class="flex flex-col items-center w-full h-full rounded-lg bg-red-100 border-pink-800 border-4 my-1 lg:my-3 px-1 lg:px-2">

        <div class="absolute" v-if="loading">
                
            <ring-loader class="rounded-full bg-red-500" ></ring-loader> 
        </div>

        <div>
            <div class="flex flex-col items-center rounded overflow-hidden shadow w-full mt-2 lg:mt-5">

                <div class="flex justify-center content-center w-20 lg:w-1/2 h-12 lg:h-24">

                    <img v-if="playersGroup.picture!=''" :src="playersGroup.picture" class="object-contain rounded-full bg-white h-20 lg:h-32">	

                    <img v-else class="object-contain bg-white w-full h-16 lg:h-32">	
                </div>

                <div class="w-full flex flex-col lg:flex-row justify-around items-baseline text-center mt-10  lg:mt-16">
                    
                    <div class="flex flex-col items-center justify-around mr-2">

                        <div class="mr-1 lg:mr-0">
                            
                            <h3 class="text-black text-xs lg:text-sm font-extrabold font-sans" >
                            <p class="text-pink-800">{{$t('business.clientName')}}</p> </h3>
                        </div>

                        <div class="mr-1 my-1 lg:my-4 lg:mr-0">
                            
                            <h3>
                            <p class="w-64 h-6 lg:h-10 lg:w-64 border-pink-800 border-2 px-2 lg:px-4 lg:border-4 rounded">
                            {{playersGroup.name}} </p></h3>
                        </div>
                    </div>
                </div>
            
                <div class="flex content-around justify-around rounded rounded-t-lg overflow-hidden mt-4 lg:mt-1 w-full">

                    <button 
                    class="myPageCard"
                    @click="showGroupMethod(playersGroup)"> {{$t('player.showGroup')}} </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    mounted(){

        // console.log(`in group card`);
    },
    
    props:{

        playersGroup: {

            type: Object
        },

        showGroupMethod: {

            type: Function
        }
    },

    data: function(){

        return{

            loading: false,
        }
    }
}
</script>

<style>

</style>